import { Modal, Tabs, TabType } from '@clickcease/cc-client-components-lib'
import React, { useState, ReactNode, CSSProperties } from 'react'
import { useTranslation } from 'react-i18next'

import { InvalidBotActivity } from './Tabs/InvalidBotActivity'
import { InvalidMalicious } from './Tabs/InvalidMalicious'
import { InvalidSuspicious } from './Tabs/InvalidSuspicious'
import { MarketingOptimizationRules } from './Tabs/MarketingOptimizationRules'

import { ThreatGroupToolTipStyled } from './ThreatGroupToolTip.styled'

interface ThreatGroupToolTipModalProps {
  isOpen?: boolean
  onOpenChange: (a: boolean) => void
  trigger?: ReactNode
  style?: CSSProperties
}

const ThreatGroupToolTip = ({
  isOpen,
  onOpenChange,
  trigger,
  style,
}: ThreatGroupToolTipModalProps) => {
  const { t } = useTranslation('PMDashboard')

  const tabs: TabType[] = [
    {
      id: 1,
      title: t('threatGroups.tooltips.invalidBotActivity.title'),
      page: <InvalidBotActivity />,
    },
    {
      id: 2,
      title: t('threatGroups.tooltips.invalidMalicious.title'),
      page: <InvalidMalicious />,
    },
    {
      id: 3,
      title: t('threatGroups.tooltips.invalidSuspicious.title'),
      page: <InvalidSuspicious />,
    },
    {
      id: 4,
      title: t('threatGroups.tooltips.marketingOptimization.title'),
      page: <MarketingOptimizationRules />,
    },
  ]

  const [activeTab, setActiveTab] = useState<TabType>(tabs[0])

  return (
    <Modal
      title={t('threatGroups.tooltips.title')}
      isOpen={isOpen}
      trigger={trigger}
      onOpenChange={onOpenChange}
      onCloseClick={() => {}}
      style={{ zIndex: 2 }}
    >
      <ThreatGroupToolTipStyled style={style}>
        <Tabs
          tabs={tabs}
          activeTab={activeTab}
          onClick={(tab: TabType) => {
            setActiveTab(tab)
          }}
        />
      </ThreatGroupToolTipStyled>
    </Modal>
  )
}

export default ThreatGroupToolTip
